/**
 * CUIT: 11 digits, the last a check digit (spec 004/005, Article III rule 2). Offline and
 * deterministic — there is no ARCA lookup in the MVP.
 */
const WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
/** Strips the separators people actually type: hyphens, dots and whitespace (`\s` covers NBSP). */
export function normalizeCuit(value) {
    return value.replace(/[\s.-]/g, "");
}
/**
 * The check digit for the first ten digits, or `null` when the remainder yields 10 — a body that
 * ARCA never issues with that prefix, so no final digit can make it valid.
 */
export function cuitCheckDigit(firstTen) {
    if (!/^\d{10}$/.test(firstTen))
        return null;
    const sum = WEIGHTS.reduce((acc, weight, i) => acc + weight * Number(firstTen[i]), 0);
    const digit = 11 - (sum % 11);
    if (digit === 11)
        return 0;
    if (digit === 10)
        return null;
    return digit;
}
export function isValidCuit(value) {
    const cuit = normalizeCuit(value);
    if (!/^\d{11}$/.test(cuit))
        return false;
    const expected = cuitCheckDigit(cuit.slice(0, 10));
    return expected !== null && expected === Number(cuit[10]);
}
export function formatCuit(value) {
    const cuit = normalizeCuit(value);
    return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`;
}
//# sourceMappingURL=cuit.js.map